import type { IPublicClientApplication } from '@azure/msal-browser';
import { loginRequest } from './msalConfig';

export async function getMicrosoftIdToken(
  instance: IPublicClientApplication,
): Promise<string> {
  await instance.clearCache();
  const loginResponse = await instance.loginPopup(loginRequest);
  await instance.clearCache();
  return loginResponse.idToken;
}
